import { ReactComponent as FilterIcon } from 'assets/icons/search/filter.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/search/search.svg';

export const search = {
  search: SearchIcon,
  filter: FilterIcon,
};
